__turbopack_context__.v({
  "notifications": "Notifications-module-scss-module__-OmvQG__notifications",
});
